import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./App.css";
import MatrixRain from "./MatrixRain";
import PrivacySettingsModal from "./PrivacySettingsModal";
import WaitlistModal from "./WaitlistModal";

function HomePage() {
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);
  const [isWaitlistModalOpen, setIsWaitlistModalOpen] = useState(false);
  const [waitlistButtonType, setWaitlistButtonType] = useState("waitlist");

  const handleExploreClick = () => {
    window.open("https://joinsarv.com/", "_blank", "noopener,noreferrer");
  };

  const handleSignUpClick = () => {
    setWaitlistButtonType("signup");
    setIsWaitlistModalOpen(true);
  };

  const handleLogInClick = () => {
    setWaitlistButtonType("login");
    setIsWaitlistModalOpen(true);
  };

  return (
    <div className="App">
      {/* Matrix Rain Background */}
      <MatrixRain />

      {/* Main Content */}
      <div className="content">
        {/* Hero Banner */}
        <section className="hero-section">
          <h1 className="company-name">M31-V1</h1>

          <div className="action-buttons">
            <button className="btn btn-secondary" onClick={handleSignUpClick}>
              <span className="btn-icon">✨</span>
              Sign Up
            </button>
            <button className="btn btn-primary" onClick={handleLogInClick}>
              <span className="btn-icon">→</span>
              Log In
            </button>
            <button className="btn btn-explore" onClick={handleExploreClick}>
              <span className="btn-icon">⊞</span>
              Explore
            </button>
          </div>
        </section>

        {/* About Section */}
        <section className="about-section">
          <div className="about-header">
            <div className="about-icon">ⓘ</div>
            <h2 className="about-title">About</h2>
          </div>
          <div className="about-content">
            <p>
              We're a collective of{" "}
              <span className="highlight">AI and technology enthusiasts</span>{" "}
              exploring the vast frontiers of artificial intelligence. We
              believe that AI can serve humanity in ways that were once{" "}
              <span className="highlight">unimaginable or unreachable</span> —
              like the distant galaxies we now observe.
            </p>
            <p>
              Just as the Andromeda Galaxy stretches across space with infinite
              possibilities, we envision a future where{" "}
              <span className="highlight">
                technology bridges the impossible
              </span>
              , making what was once out of reach accessible to all. The
              question we explore isn't just what AI can do, but{" "}
              <span className="highlight">what humanity can become</span> when
              empowered by it.
            </p>
          </div>
        </section>

        {/* Projects Section */}
        <section className="projects-section">
          <div className="projects-header">
            <div className="projects-icon">⚙</div>
            <h2 className="projects-title">Projects</h2>
          </div>
          <div className="projects-content">
            <p>
              We're building{" "}
              <span className="highlight">intelligent applications</span> that
              serve humanity across diverse domains — from healthcare and
              education to creativity and human connection.
            </p>
            <p>
              Our work aims to illuminate paths forward, demonstrating that
              we're not witnessing the end of an era, but rather standing at the{" "}
              <span className="highlight">edge of a new frontier</span> — a
              cosmic journey where technology and humanity converge to create
              something extraordinary.
            </p>
          </div>
        </section>

        {/* Contact Section */}
        <section className="contact-section">
          <div className="contact-header">
            <div className="contact-icon">✉</div>
            <h2 className="contact-title">Contact</h2>
          </div>
          <div className="contact-content">
            <p>
              For business inquiries or if you need help, contact us at:{" "}
              <a href="mailto:info@m31v1.com" className="contact-email">
                info@m31v1.com
              </a>
            </p>
          </div>
        </section>

        {/* Footer Links */}
        <div className="footer-links">
          <Link to="/terms" className="footer-link">
            Terms of Service
          </Link>
          <Link to="/privacy" className="footer-link">
            Privacy Policy
          </Link>
          <Link to="/privacy-settings" className="footer-link">
            Privacy Settings
          </Link>
        </div>

        {/* Privacy Settings Modal */}
        <PrivacySettingsModal
          isOpen={isPrivacyModalOpen}
          onClose={() => setIsPrivacyModalOpen(false)}
        />

        {/* Waitlist Modal */}
        <WaitlistModal
          isOpen={isWaitlistModalOpen}
          onClose={() => setIsWaitlistModalOpen(false)}
          buttonType={waitlistButtonType}
        />

        {/* Footer */}
        <footer className="footer">
          <p>© 2025 M31 LLC. All rights reserved.</p>
        </footer>
      </div>
    </div>
  );
}

export default HomePage;
